// RestaurantList.js
import React, { useEffect, useState } from 'react'
import axios from 'axios'
import CircularProgress from '@mui/material/CircularProgress'
import { useUser } from '../../context/UserContext'
import './RestaurantStyle.css'

export const RestaurantList = ({ setSelectedRestaurant }) => {
  const { userInfo } = useUser()
  const [restaurants, setRestaurants] = useState([])
  const [loading, setLoading] = useState(true)
  const [searchText, setSearchText] = useState('')

  useEffect(() => {
    console.log('User info in RestaurantList:', userInfo)
  }, [userInfo])

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.post(
          process.env.REACT_APP_API_URL + '/restaurantsGeo',
          { filter: {}, source: 3 },
          { headers: { 'Content-Type': 'application/json' } }
        )

        const processedData = response.data.data.map(restaurant => {
          if (restaurant.logo) {
            restaurant.logo = `https://haproxy.abspos.pl/media/${restaurant.logo}`
          }
          return restaurant
        })

        setRestaurants(processedData)
        setLoading(false)
      } catch (error) {
        console.error('Error fetching', error)
        setLoading(false)
      }
    }

    fetchData()
  }, [])

  const handleSearchTextChange = event => {
    setSearchText(event.target.value)
  }

  return (
    <div className='restaurant-list'>
      <div className='search-input'>
        <input type='text' placeholder='Szukaj' value={searchText} onChange={handleSearchTextChange} />
      </div>
      {loading ? (
        <div className='loader-container'>
          <CircularProgress style={{ color: '#FF7A00' }} />
        </div>
      ) : (
        <div className='restaurant-grid'>
          {restaurants
            .filter(
              restaurant =>
                restaurant.name.toLowerCase().includes(searchText.toLowerCase()) && restaurant.loyalty_program === true
            )
            .map(restaurant => {
              console.log('Rendering restaurant:', restaurant)

              const localData = userInfo?.locals?.find(local => local.local_id === restaurant.id)

              if (localData) {
                console.log(`Найден ресторан с local_id ${restaurant.id}:`, localData)
              } else {
                console.log(`Нет данных лояльности для ресторана с local_id ${restaurant.id}`)
              }

              return (
                <div
                  key={restaurant.id}
                  className='restaurant-item'
                  onClick={() => setSelectedRestaurant(restaurant)}
                  style={{ position: 'relative' }}
                >
                  {restaurant.logo ? <img src={restaurant.logo} alt={restaurant.name} /> : <p>Brak logotypu</p>}
                  {localData && <div className='points-badge'>{localData.points} pkt</div>}
                </div>
              )
            })}
        </div>
      )}
    </div>
  )
}
